import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { I18n } from 'react-redux-i18n';

import { useAppDispatch } from '../../hooks/redux/useApp';
import { authenticateWithPasskey } from '../../modules/session';
import { isPasskeySupported } from '../../helpers/passkeys';
import { grecaptchaToken } from '../../helpers/grecaptcha';

interface PasskeySignInButtonProps {
  remember: boolean;
}

const PasskeySignInButton = ({ remember }: PasskeySignInButtonProps) => {
  const dispatch = useAppDispatch();
  const [busy, setBusy] = useState(false);

  if (!isPasskeySupported()) {
    return null;
  }

  const handleClick = async () => {
    setBusy(true);
    try {
      await dispatch(
        authenticateWithPasskey(() => grecaptchaToken('login'), remember)
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      basic
      fluid
      className="login-button passkey-sign-in"
      loading={busy}
      disabled={busy}
      onClick={handleClick}
    >
      <Icon name="key" aria-hidden="true" />
      {I18n.t('authentication.login.passkey')}
    </Button>
  );
};

export default PasskeySignInButton;
